'use strict';/* global define:false */define('modules/core/modules/utils/directives/note/controller',[],function(){'use strict';function controller($scope){// jshint validthis:true
// jshint latedef:false
Object.defineProperties(this,{author:{get:function get(){return!!$scope.author;}}});}controller.$inject=['$scope'];return controller;});
